module.exports = __webpack_public_path__ + "img/footer.949df8ef.png";